import { createAction, props } from '@ngrx/store';
import { Bounds } from 'app/shared/ll/models/bounds';
import { AvailableLayer, Feature, LayerItemDef } from './layer.model';
import { WithinBounds } from './response.model';

interface LayerRequest {
    key: string;
    args: any;
}

export const loadLayersDef = createAction('[Layers] Load layers definition');

export const layersDefLoaded = createAction('[Layers] Layers definition loaded', props<{ layersDef: LayerItemDef[] }>());

export const withinBoundsLayersLoaded = createAction('[Layers] Within bounds layers loaded', props<{ withinBounds: WithinBounds[] }>());

export const changeAvailableLayers = createAction('[Layers] Change available layers', props<{ availableLayers: AvailableLayer[] }>());

export const selectLayer = createAction('[Layers] Select layer', props<{ key: string; args: any; updating: boolean }>());

export const redoSearch = createAction('[Layers] Redo search layer', props<{ key: string }>());

export const toggleLayerUpdate = createAction('[Layers] Toggle layer update', props<{ key: string, updating: boolean }>());

export const refreshLayers = createAction('[Layers] Refresh layers', props<{ bounds: Bounds; layers: LayerRequest[] }>());

export const downloadLayer = createAction('[Layers] Download layer', props<{ bounds: Bounds; layer: LayerRequest }>());

export const mapLayersNamesToggle = createAction('[Layers] Display layer names on map', props<{ mapLayerNames: boolean }>());

export const toggleShowParcels = createAction('[Layers] Toggle show parcels outline', props<{ value: boolean }>());

export const unselectLayer = createAction('[Layers] Unselect layer', props<{ key: string }>());

export const removeLayers = createAction('[Layers] Remove layers', props<{ keys: string[] }>());

export const clearLayers = createAction('[Layers] Clear layers');

export const failLayer = createAction('[Layers] Failed layer', props<{ key: string, reason?: string }>());

export const layerFeaturesLoaded = createAction('[Layers] Features Loaded', props<{ layerKey: string, features: Feature[] }>());
